import { jsx as y } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import l from "@mui/material/CardHeader";
import g from "styled-components";
const h = {
  root: "cardHeaderRoot",
  content: "cardHeaderContent",
  action: "cardHeaderAction"
}, c = g(l).withConfig({
  displayName: "StyledCardHeader"
})([
  "&&.cardHeaderRoot{font-size:",
  ";text-align:left;",
  ";}&& .cardHeaderAction{margin:0px 0px 0px 16px;align-self:center;}&& .titleTypographyRoot{color:",
  ";font-size:",
  ";font-weight:",
  ";line-height:1.2em;}&& .subheaderTypographyRoot{color:",
  ";font-size:",
  ";}"
], ({ theme: e }) => e.typography.body400.fontSize, ({ $disablePadding: e }) => e ? "padding: 0px" : "", ({ theme: e }) => e.text.primary, ({ theme: e }) => e.typography.body400.fontSize, ({ theme: e }) => e.typography.fontWeightRegular, ({ theme: e }) => e.text.tertiary, ({ theme: e }) => e.typography.body200.fontSize), f = /* @__PURE__ */ n(({ children: e, classes: o, disablePadding: t = !1, subheaderTypographyProps: r, titleTypographyProps: a, ...d }, p) => {
  const i = {
    classes: {
      root: "titleTypographyRoot"
    },
    ...a
  }, s = {
    classes: {
      root: "subheaderTypographyRoot"
    },
    ...r
  };
  return /* @__PURE__ */ y(c, {
    ...d,
    ref: p,
    classes: {
      ...h,
      ...o
    },
    titleTypographyProps: i,
    subheaderTypographyProps: s,
    $disablePadding: t,
    children: e
  });
});
f.displayName = "CardHeader";
export {
  f as default
};
